<template>
  <div>
    <div class="jiazheng-nav">
      <div class="flex lr-flex nav-c top-nav">
        <img class="imglogoG" src="@/assets/images/logos/jiazheng-logo.png" alt="" />
        <div>
          <template v-if="!token">
            <el-button @click="jumpLogin('jiazheng_homepage')">
              学员登录
            </el-button>
            <el-button @click="jumpOrgan">
              机构登录
            </el-button>
            <el-button @click="jumpRegister">
              机构注册
            </el-button>
          </template>
          <template v-else>
            <div class="user-top">
              <account :replacePage="'jiazheng_homepage'"/>
            </div>
          </template>
        </div>
      </div>
      <div class="nav-list">
        <div class="nav-c">
          <div class="gongxin-nav-bar fl">
            <p class="item-nav fl" 
              v-for="(item) in navList" 
              :key="item.id"
              :class="{active:item.name==activeName}"
              @click="clickNav(item)"
            >
              {{item.name}}
            </p>
            <el-dropdown class="move fl" placement="bottom" trigger="click" ref="messageDrop">
              <span class="el-dropdown-linkapp">
                <span class="dropdown-title link-app">移动端</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="nav-jz-menu">
                <el-dropdown-item class="nav-item">
                  <div class="dl-wrap">
                    <div class="img-wrap">
                      <img v-if="netImg" src="@assets/user/jiazheng_qrcode.png" alt="" class="app-download" />
                      <img v-if="uatImg" src="@assets/user/jiazheng_fat.png" alt="" class="app-download" />
                      <img src="@assets/user/border-dec.png" class="border border1"/>
                      <img src="@assets/user/border-dec.png" class="border border2"/>
                    </div>
                    
                    <p>移动学习 随时随地</p>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import $ from 'jquery'
import URL from '../../../../config/url';
import account from './account.vue'
export default {
  name: 'jiazhengNav',
  components: {
    account,
  },
  data () {
    return {
      activeName:'',
      activeNav:'',
      uatImg:false,
      netImg:false,
      userInfo: {},
      mode: '0', //  0:其他 1' 学习中心 '2': 模拟考试 ‘3’正式考试
      token: '',
      couseIds: {},
      navList: []
    }
  },
  created () {
    this.setDefaultInfo();
    setTimeout(() => {
      this.getNavs();
    },100)
    
    
    // 
  },
  watch: {
    $route() {
      this.setDefaultInfo();
      setTimeout(() => { //路由跳转
        this.getNavs();
      }, 100)
    }
  },
  async mounted () {
    // 
    // setTimeout(() => { //刷新
    //   this.getNavs();
    // //   this.setDefaultInfo();
      
    // }, 100)
    
    // if (sessionStorage.getItem('dy-mode')) {
    //   this.mode = sessionStorage.getItem('dy-mode') || '0';
    // }
    let host = window.location.host;
    if(host=='gdjz-pc.fat.wdeduc.com'){
        this.uatImg=true
        this.netImg=false
    }else{
        this.uatImg=false
        this.netImg=true
    }
  },
  methods: {
    // 获取导航头数据
    getNavs() {
      this.$api.homeJz.getMenuNew(URL.confUrl).then((res) => {
          if (res.data.menuList) {
              this.navList = res.data.menuList;
              if(sessionStorage.getItem('activeName')){
                this.activeName=sessionStorage.getItem('activeName');
              }else{
                this.activeName=res.data.menuList[0].name;
              }
              // this.$refs.messageDrop.show();
              this.getActiveNav();
          }
      })
      
    },
    // 选中问题
    getActiveNav() {
        let jzTrainInfo = JSON.parse(localStorage.getItem('jzTrainInfo')) || {};
        this.navList.forEach((d)  => {
            if(d.name=='模拟考试' || d.name=='正式考试'){
              d.url=jzTrainInfo.type==1?'/learning/taskDetail':'/course/catalog'
            }
        })
    },
    jumpOrgan() {
        let hostname = window.location.hostname;
        let arr=hostname.split('.')
        const port = window.location.port;
        const isIP=/^(\d+)\.(\d+)\.(\d+)\.(\d+)$/;
        let isDTYProEnv = !hostname.split('.').splice(3).join('.'); //线上的定制化主题
        let testUrl;
        let shengchanUrl;
        if(isDTYProEnv){
          shengchanUrl = arr.splice(1).join('.');
        }else{
          testUrl = arr.splice(1,1).join('.') +'.wdeduc.com'
        }
        let path = `https://hrss-main.${isDTYProEnv ? shengchanUrl:testUrl}`;
        if(isIP.test(hostname) || !!port){
            path = 'https://hrss-main.testing3.wdeduc.com';
        } else if (hostname.includes('fat')) {
            path = 'https://hrss-main.fat.wdeduc.com';
        }
        window.location.replace(path);
    },
    jumpRegister() {
      this.$router.push('register')
    },
    setDefaultInfo() {
      this.mode = this.$route.query.dymode || '0';
      this.token = localStorage.getItem('token');
      if (this.token) {
        this.$api.homeJz.getJiazhengExam().then((res) =>  {
            if(res.success){
                localStorage.setItem('jzTrainInfo', JSON.stringify(res.data));
            }
        })
      }
    },
    // setActive(item) {
    //   // 学习中心，模拟考试的内部跳转需要处理。
    //   let flag = false;
    //   this.mode = this.$route.query.dymode || '0';
    //   if (this.mode === item.mode) {
    //     flag = !!item.activePaths.includes(this.activeNav);
    //   }
      
    //   return flag;
    // },
    clickNav(item) {
      let jzTrainInfo = JSON.parse(localStorage.getItem('jzTrainInfo')) || {};
      if (item.url.indexOf('http') === -1) {
        this.activeName=item.name;
        sessionStorage.setItem('activeName',this.activeName)
          if(item.name=='模拟考试' || item.name=='正式考试'){
            let type='3';
            if(item.name=='模拟考试'){
              type=2
            }
            let params={};
            if(jzTrainInfo.type==1){
              params={
                id:item.name=='模拟考试'?jzTrainInfo.practiceExamTrainId:jzTrainInfo.formalExamTrainId,
                dymode: type,
                taskType:2,
              }
            }else{
              params={
                taskId:item.name=='模拟考试'?jzTrainInfo.practiceExamTrainId:jzTrainInfo.formalExamTrainId,
                taskType:1,
                dymode: type,
              }
            }
            this.token = localStorage.getItem('token');
            if(this.token){
              this.$router.push({
                  path: item.url,
                  query: params
              });
            }else{
              this.jumpLogin();
            }
            
            
            // this.$router.push({
            //     path: item.url,
            //     query:{
            //       id:jzTrainInfo.practiceExamTrainId,
            //       dymode:type
            //     }
            // });
          }else{
             this.$router.push({
                path: item.url,
            });
          }
      } else {
          window.open(item.url, 'newW');
      }
    },
    jumpLogin() {
      localStorage.setItem('loginBy',0)
      this.$router.push(`/login?name=jiazheng_homepage`).catch()
    },
  }
}
</script>
<style lang="stylus" scoped>
@import './jiazhengNav.styl';
</style>
